import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { MedOptionType } from "@mk/med-ui";
import { env } from "@environments/environment";
import { PAGINATION_OPTIONS } from "@app/components/supplies/supplies.component";
import { DataService } from "@app/services/data.service";
import { AccountService } from "@app/services/account.service";
import { OrganizationApiService } from "@app/services/organization-api.service";
import { OrganizationViewModel } from "@app/models/organization.model";
import { OrganizationShortModel } from "@app/models/organization-short.model";
import { UserDto } from "@app/ui_models/userDto";
import { UserController } from "@app/ui_controllers/userController";
import { ConfirmationService } from "primeng/api";
import {FilterService, RecipientsDOZModel, RecipientsMZUModel} from "@app/services/filter.service";
import {TableColResizeEvent} from "primeng/table";

interface Recipient {
    id: number
    year: number
    directionId: number
    directionName: string
    regionId: number
    organizations: any []
    experts: UserDto []
}

@Component({
  selector: "app-recipients",
  templateUrl: "./recipients.component.html",
  styleUrls: ["./recipients.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class RecipientsComponent implements OnInit {

  constructor(private confirmationService: ConfirmationService,
              private readonly http: HttpClient,
              private readonly organizationApiService: OrganizationApiService,
              private readonly userController: UserController,
              public filter: FilterService,
              public dataService: DataService,
              public accountService: AccountService) {
  }

  organizationsAll: OrganizationShortModel[] = [];
  expertsAll: UserDto[] = [];
  recipientsAll: Recipient[] = [];
  selectedRecipient: any = {};
  tableBody1: any[] = [];
  isDoz = this.dataService.userRoleValue.getValue() === "DOZ";
  tabHeader: { label: string; key: string; date: boolean; filter: boolean; size: string; role?: string; width: string}[] = this.isDoz ? tabHeaderDoz : tabHeaderMzu;
  emptyResponse = false;
  selectedOrganizations: OrganizationShortModel[] = [];
  selectedExperts: UserDto[] = [];
  directions: any = [];
  tableBody:  { [key: string]: any; }[] = [];
  rows = 0;
  totalRows = 0;
  pageSize = 10;
  selectedPageNumber = 1;
  addRecipientModal = false;
  addExpertModal = false;
  selectedOrganisations: any;
  years: MedOptionType<any>[] = [
    { value: 2020, label: "2020" },
    { value: 2021, label: "2021" },
    { value: 2022, label: "2022" },
    { value: 2023, label: "2023" },
    { value: 2024, label: "2024" },
    { value: 2025, label: "2025" },
    { value: 2026, label: "2026" },
    { value: 2027, label: "2027" }
  ];
  year = 2025;
  showedOnPage = 10;
  readonly paginationOptions: MedOptionType<number>[] = PAGINATION_OPTIONS;
  directionForModal = "";
  loadingCounter = 0;
  disabledFlag = false;
  addResponsibleForDirectionModal = false;
  data: RecipientsDOZModel = {} as RecipientsDOZModel;
  data2: RecipientsMZUModel = {} as RecipientsMZUModel;
  expertsChanged = false;
  recipientsChanged = false;

  ngOnInit(): void {
    this.getOrganizationsAll();
    // this.getRecipientsAll(this.year);
    this.userController.getExperts(0, 1000).subscribe(data => {
      this.expertsAll = data.content;
      if ("MZU" === this.dataService.userRoleValue.getValue()) {
        this.expertsAll = this.expertsAll.filter((expert: any): boolean => expert.roles?.includes("logistics-mpu-sub-manager"));
      } else if ("DOZ" === this.dataService.userRoleValue.getValue()) {
        this.expertsAll = this.expertsAll.filter((expert: any): boolean => expert.id !== this.accountService.userId());
      }
    });
    this.loadColumnOrder();
    this.filter.recipientsDOZSubject.subscribe(data => {
      this.data = data;
      this.getRecipientsAll(this.year);
    })
    this.filter.recipientsMZUSubject.subscribe(data => {
      this.data2 = data;
      this.getRecipientsAll(this.year);
    })
  }

  saveColumnOrder() {
    const columnOrderName = this.isDoz ? "recipientDozColumnOrder" : "recipientMzuColumnOrder";
    localStorage.setItem(columnOrderName, JSON.stringify(this.tabHeader));
  }

  loadColumnOrder() {
    const columnOrderName = this.isDoz ? "recipientDozColumnOrder" : "recipientMzuColumnOrder";
    const savedOrder = localStorage.getItem(columnOrderName);
    if (savedOrder) {
      this.tabHeader = JSON.parse(savedOrder);
    }
  }

  getRecipientsAll(year: number): void {
    const timeoutId = setTimeout(() => {
      this.loadingCounter++;
    }, 300);
    this.http.get<any>(env.logisticsServiceBackend + `/logistics/v1/dictionary/direction/${year}`).subscribe(data => {
      this.directions = data;
      const userRole: string = this.getCurrentUserRole();
      // eslint-disable-next-line rxjs/no-nested-subscribe
      this.http.get<Recipient[]>(env.logisticsServiceBackend + `/logistics/v1/recipients/${userRole}/${year}`).subscribe((data: Recipient[]): void => {
        this.recipientsAll = data;
        this.mergeDirectionsToRecipients();
        this.recipientsAll = this.filterData(data);
        this.tableBody1 = this.recipientsAll.slice((this.selectedPageNumber - 1) * this.pageSize, this.pageSize + (this.pageSize * (this.selectedPageNumber - 1)));
        this.totalRows = this.recipientsAll.length;
        this.emptyResponse = this.tableBody1.length === 0;
        if (this.loadingCounter === 0) {
          clearTimeout(timeoutId);
        } else {
          this.loadingCounter--;
        }
      });
    });
  }

  filterData(data: Recipient[]): Recipient[] {
    // if (this.data.experts.length > 0 || this.data.shortListed.length > 0 || this.data.direction.length > 0) {
    let mzuFilterIsEmpty = this.data2.direction[0] === undefined && this.data2.shortListed[0] === undefined;
    let filterBy: RecipientsDOZModel|RecipientsMZUModel = !mzuFilterIsEmpty ? this.data2 : this.data;
    let isDOZModel = (model: RecipientsDOZModel | RecipientsMZUModel): model is RecipientsDOZModel => {
      return 'experts' in model;
    };
      data = data.filter((recipient: Recipient): boolean => {
        let result = true;
        // if (this.data.experts.length > 0) {
        //   result = result && recipient.experts.some((expert: any): boolean => this.data.experts.includes(expert.id));
        // }
        // if (this.data.shortListed.length > 0) {
        //   result = result && recipient.organizations.some((organization: any): boolean => this.data.shortListed.includes(organization.id));
        // }

        if (isDOZModel(filterBy) && filterBy.experts.length > 0) {
          if (recipient.experts.length > 0) {
            result = result && recipient.experts.some((expert: any): boolean => expert.firstName.includes(filterBy.experts[0]) || expert.lastName.includes(filterBy.experts[0]));
          } else {
            result = false;
          }
        } else {
          if (!isDOZModel(filterBy) && filterBy.responsibleForDirection.length > 0) {
            if (recipient.experts.length > 0) {
              result = result && recipient.experts.some((expert: any): boolean => expert.firstName.includes(filterBy.responsibleForDirection[0]) || expert.lastName.includes(filterBy.responsibleForDirection[0]));
            } else {
              result = false;
            }
          }
        }

        if (filterBy.direction.length > 0) {
          if (recipient.directionName) {
            result = result && recipient.directionName.includes(filterBy.direction[0]);
          } else {
            result = false;
          }
        }

        if (filterBy.shortListed.length > 0) {
          if (recipient.organizations.length > 0) {
            result = result && recipient.organizations.some((organization: any): boolean => organization.fullName.includes(filterBy.shortListed[0]));
          } else {
            result = false;
          }
          // result = result && recipient.organizations.some((organization: any): boolean => organization.fullName.includes(this.data.shortListed[0]));
        }
        // else if (!recipient.directionName) {
        //   result = false;
        // }
        return result;
      })
    // }
    return data;
  }

  getDirectionNameByDirectionId(directionId: number): string {
    let directionName: string = directionId + "";
    const directions: any [] = this.directions.filter((direction: any): boolean => direction.id === directionId);
    if (directions.length > 0) {
      directionName = directions[0].shortName;
    }
    return directionName;
  }

  getOrganizationsAll(): void {
    let params: HttpParams = new HttpParams();

    params = params.append("page", 0);
    params = params.append("size", 1000);
    this.organizationApiService.getOrganizationsForRecipientsMapping(this.dataService.userRoleValue.getValue().toLowerCase(), params).subscribe(data => {
      this.organizationsAll = data;
    });
  }

  trackByIndex(index: number): number {
    return index;
  }

  getFirstShowedRowIndex() {
    return this.selectedPageNumber === 1 ? 0 : (this.selectedPageNumber - 1) * this.pageSize;
  }

  showModal(row: any): void {
    this.selectedOrganizations = this.convertToOrgObj(row.organizations);
    this.selectedRecipient = row;
    this.addRecipientModal = true;
    this.recipientsChanged = false;
    this.directionForModal = this.getDirectionNameByDirectionId(row["directionId"]);
  }

  showModalForExperts(row: any): void {
    this.selectedExperts = row.experts;
    this.selectedRecipient = row;
    this.addExpertModal = true;
    this.expertsChanged = false;
    this.directionForModal = this.getDirectionNameByDirectionId(row["directionId"]);
  }

  showModalForResponsibles(row: any): void {
    this.selectedExperts = row.experts;
    this.selectedRecipient = row;
    this.addResponsibleForDirectionModal = true;
    this.directionForModal = this.getDirectionNameByDirectionId(row["directionId"]);
  }

  convertToOrgObj(orgs: any): OrganizationShortModel[] {
    const returnOrgs: OrganizationShortModel[] = [];
    orgs.forEach((org: any) => {
      returnOrgs.push(new OrganizationShortModel({ id: org.id, fullName: org.fullName, code: org.code }));
    });
    return returnOrgs;
  }

  addOrganizationsToRecipient(): void {
    const request: any = { id: 0, directionId: 0, year: 0, organizations: [] };
    const userRole: string = this.getCurrentUserRole();
    request.id = this.selectedRecipient?.id;
    request.directionId = this.selectedRecipient?.directionId;
    request.year = this.selectedRecipient?.year;
    request.organizations = this.selectedOrganizations.map((organization: any): OrganizationViewModel => (new OrganizationViewModel({ id: organization.id, code: organization.code })));
    let requestToBackend: any = this.http.post(env.logisticsServiceBackend + `/logistics/v1/recipients/${userRole}`, request);
    if (request.id) {
      requestToBackend = this.http.put(env.logisticsServiceBackend + `/logistics/v1/recipients/id/${request.id}`, request.organizations);
    } else {
      request.id = null;
    }
    requestToBackend.subscribe(() => {
      this.addRecipientModal = false;
      this.selectedRecipient = {};
      this.selectedOrganisations = [];
      this.getRecipientsAll(this.year);
    });

  }

  addExpertsToRecipient(): void {
    const request: any = { id: 0, directionId: 0, year: 0, organizations: [], experts: [] };
    const userRole: string = this.getCurrentUserRole();
    request.id = this.selectedRecipient?.id;
    request.directionId = this.selectedRecipient?.directionId;
    request.year = this.selectedRecipient?.year;
    // request.organizations = this.selectedOrganizations.map((organization: any): OrganizationViewModel => (new OrganizationViewModel({ id: organization.id, code: organization.code })));
    request.experts = this.selectedExperts;
    let requestToBackend: any = this.http.post(env.logisticsServiceBackend + `/logistics/v1/recipients/${userRole}`, request);
    if (request.id) {
      requestToBackend = this.http.put(env.logisticsServiceBackend + `/logistics/v1/recipients/id/experts/${request.id}`, request.experts);
    } else {
      request.id = null;
    }
    if (!this.disabledFlag) {
      this.disabledFlag = true;
      requestToBackend.subscribe(() => {
        this.addExpertModal = false;
        this.addResponsibleForDirectionModal = false;
        this.selectedRecipient = {};
        // this.selectedOrganisations = [];
        this.selectedExperts = [];
        this.getRecipientsAll(this.year);
        this.disabledFlag = false;
      });
    }

  }

  getCurrentUserRole(): string {
    return this.dataService.userRoleValue.getValue().toLowerCase();
  }

  deleteOrganizationFromRecipient(event: Event, recipientId: number, organizationId: number): void {

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Підтвердіть видалення отримувача",
      acceptIcon: "mr-1",
      rejectIcon: "mr-1",
      acceptLabel: "Видалити",
      rejectLabel: "Відмовитись",
      rejectButtonStyleClass: "p-button-outlined p-button-sm",
      acceptButtonStyleClass: "p-button-sm",
      accept: () => {
        this.http.delete<any>(env.logisticsServiceBackend + "/logistics/v1/recipients/unlink/" + recipientId + "/" + organizationId).subscribe(() => {
          this.getRecipientsAll(this.year);
        });
      },
      reject: () => {
        console.log("rejected");
      },
    });

  }

  deleteExpertsFromRecipient(recipientId: number, expertId: number): void {
    this.http.delete<any>(env.logisticsServiceBackend + "/logistics/v1/recipients/unlink/experts/" + recipientId + "/" + expertId).subscribe(() => {
      this.getRecipientsAll(this.year);
    });
  }

  yearSelected($event: any) {
    if ($event) {
      this.getRecipientsAll(this.year);
      this.selectedPageNumber = 1;
    }
  }

  pageChange(pageNumber: number): void {
    this.selectedPageNumber = pageNumber;
    this.getRecipientsAll(this.year);
  }

  pageSizeChanged(pageSize: number): void {
    this.pageSize = pageSize;
    this.selectedPageNumber = 1;
    this.getRecipientsAll(this.year);
  }

  private mergeDirectionsToRecipients() {
    this.directions.forEach((direction: any) => {
      if (!this.recipientsAll.some(recipient => recipient.directionId === direction.id)) {
        const newRecipient: Recipient = {
          id: 0,
          year: direction.year,
          directionId: direction.id,
          directionName: this.getDirectionNameByDirectionId(direction.id),
          regionId: 0,
          organizations: [],
          experts: [],
        };
        this.recipientsAll.push(newRecipient);
      } else {
        const recipient = this.recipientsAll.find(recipient => recipient.directionId === direction.id);
        if (recipient) {
            recipient.directionName = this.getDirectionNameByDirectionId(direction.id);
        }
      }
    });

  }

  isVisibleFilters(): boolean {
    return this.filter.recipientsFilter;
  }

  handleColumnResize($event: TableColResizeEvent) {
    this.tabHeader.forEach(element => {
      if (element.label === $event.element.innerText.trim()) {
        element.width = $event.element.clientWidth + "px";
      }
    })
    this.saveColumnOrder();
  }

  onExpertChange($event: any) {
    this.expertsChanged = true;
  }

  onRecipientsChange($event: any) {
    this.recipientsChanged = true;
  }
}

export const tabHeaderMzu = [
  { key: "1", label: "Напрям", date: false, filter: true, size: "big", width: "initial" },
  { key: "2", label: "Обрані отримувачі", date: false, filter: true, size: "big", width: "initial" },
  { key: "3", label: "За замовчуванням", date: false, filter: true, size: "small", role: "MZU", width: "initial" },
  { key: "4", label: "Відповідальний за напрям", date: false, filter: true, size: "small", role: "MZU", width: "initial" },
];

export const tabHeaderDoz = [
  { key: "1", label: "Напрям", date: false, filter: true, size: "big", width: "initial" },
  { key: "2", label: "Обрані отримувачі", date: false, filter: true, size: "big", width: "initial" },
  { key: "3", label: "Експерти напряму", date: false, filter: true, size: "small", role: "DOZ", width: "initial" },
];
